import axios, { AxiosError } from 'axios';
import { CommonRootState } from '../combineReducers';
import { EnvelopeStatus, IEnvelope } from '../interfaces/envelope';
import { FilterOptionValueType } from '@pec/aion-ui-odata/types/odataFilterOption';
import { OdataComparator } from '@pec/aion-ui-odata/types/odataComparator';
import { QueryBuilder } from '@pec/aion-ui-odata/builders/odataQueryBuilder';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

const { Equals, In } = OdataComparator;
const { AssigneeAssigned, OwnerAssigned, Pending } = EnvelopeStatus;

const fetchEsignatureDocumentsCountRequest = () =>
  ({
    type: 'FETCH_ESIGNATURE_DOCUMENTS_COUNT_REQUEST'
  } as const);

const fetchEsignatureDocumentsCountSuccess = (payload: number) =>
  ({
    type: 'FETCH_ESIGNATURE_DOCUMENTS_COUNT_SUCCESS',
    payload
  } as const);

const fetchEsignatureDocumentsCountFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: 'FETCH_ESIGNATURE_DOCUMENTS_COUNT_FAILURE',
    error
  } as const;
};

const getClientParams = (organizationId: string) =>
  new QueryBuilder()
    .top(0)
    .filter(f => f.filterBy('ownerTypeId', Equals, organizationId).filterBy('status', Equals, OwnerAssigned))
    .toQueryParam();

const getContractorParams = (organizationId: string) =>
  new QueryBuilder()
    .top(0)
    .filter(f =>
      f.filterBy('assigneeTypeId', Equals, organizationId).filterBy('status', In, [AssigneeAssigned, Pending], {
        valueType: FilterOptionValueType.EnumType
      })
    )
    .toQueryParam();

export const fetchEsignatureDocumentsCount = (
  organizationId: string,
  isAssignee: boolean
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchEsignatureDocumentsCountRequest());

    const params = isAssignee ? getContractorParams(organizationId) : getClientParams(organizationId);

    const { data } = await axios.get<{ value: IEnvelope[]; '@odata.count': number }>('/api/v3.01/eSignatureEnvelopes', {
      params
    });

    dispatch(fetchEsignatureDocumentsCountSuccess(data['@odata.count']));
  } catch (error) {
    dispatch(fetchEsignatureDocumentsCountFailure(error));
  }
};

export type Actions =
  | ReturnType<typeof fetchEsignatureDocumentsCountRequest>
  | ReturnType<typeof fetchEsignatureDocumentsCountSuccess>
  | ReturnType<typeof fetchEsignatureDocumentsCountFailure>;
